import _objectSpread from "/var/lib/jenkins/workspace/wyt-admin/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, mergeProps as _mergeProps, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock } from "vue";

const _hoisted_1 = /*#__PURE__*/_createTextVNode("查询");

const _hoisted_2 = /*#__PURE__*/_createTextVNode("取消");

const _hoisted_3 = /*#__PURE__*/_createTextVNode("确认");

import { ref, computed, watch } from 'vue';
import { getVexTableProps } from '@/config';
import { getPersonList } from '@/request';
import { ElMessage } from 'element-plus';
import { useStore } from 'vuex';
export default {
  name: 'AddPersonModal',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue', 'success'],

  setup(__props, {
    emit
  }) {
    const props = __props;
    const store = useStore();
    store.dispatch('getDictList');
    const dictList = computed(() => store.state.dictList);
    const table = ref();
    const visible = computed({
      get() {
        return props.modelValue;
      },

      set(val) {
        emit('update:modelValue', val);
      }

    });
    const defaultForm = {
      taskFlag: '0',
      hasSupplier: '1',
      userStatus: '1',
      salesmanKeyWd: '',
      supplierKeyWd: '',
      structureName: ''
    };
    const form = ref(_objectSpread({}, defaultForm));
    watch(() => props.modelValue, newVal => {
      if (newVal) {
        form.value = _objectSpread({}, defaultForm);
      }
    });
    const tableOptions = getVexTableProps({
      columns: [{
        type: 'checkbox',
        width: '50px'
      }, {
        title: '登录账号',
        field: 'loginName',
        width: '150px',
        showOverflow: true
      }, {
        title: '姓名',
        field: 'linkMan',
        width: '100px'
      }, {
        title: '联系人手机',
        field: 'linkPhone',
        showOverflow: true
      }, {
        title: '所属团队',
        field: 'supplierName',
        showOverflow: true
      }, {
        title: '所属下级团队',
        field: 'structureName',
        showOverflow: true
      }, {
        title: '业务区域',
        field: 'salesmanAreaName',
        showOverflow: true
      }],
      proxyConfig: {
        ajax: {
          query: ({
            page
          }) => new Promise(res => {
            getPersonList(_objectSpread({
              page: page.currentPage,
              rows: page.pageSize
            }, form.value)).then(data => {
              var _data$rows;

              data === null || data === void 0 ? void 0 : (_data$rows = data.rows) === null || _data$rows === void 0 ? void 0 : _data$rows.forEach(row => {
                row.id = row.supUserId;
                row.supplier_name = row.supplierName;
                row.submit_type = 'person';
              });
              res({
                total: data.total,
                result: data.rows
              });
            });
          })
        }
      }
    });

    function confirm() {
      const selectRows = table.value.getCheckboxRecords();

      if (!selectRows.length) {
        ElMessage.warning('请勾选后再进行操作!');
        return;
      }

      visible.value = false;
      emit('success', selectRows);
    }

    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");

      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_col = _resolveComponent("el-col");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_row = _resolveComponent("el-row");

      const _component_el_form = _resolveComponent("el-form");

      const _component_vxe_grid = _resolveComponent("vxe-grid");

      const _component_el_dialog = _resolveComponent("el-dialog");

      return _openBlock(), _createBlock(_component_el_dialog, {
        title: "添加人员",
        modelValue: _unref(visible),
        "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => _isRef(visible) ? visible.value = $event : null),
        "destroy-on-close": "",
        "append-to-body": "",
        width: "1000px"
      }, {
        footer: _withCtx(() => [_createVNode(_component_el_button, {
          onClick: _cache[4] || (_cache[4] = $event => visible.value = false)
        }, {
          default: _withCtx(() => [_hoisted_2]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: confirm
        }, {
          default: _withCtx(() => [_hoisted_3]),
          _: 1
        })]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          inline: true
        }, {
          default: _withCtx(() => [_createVNode(_component_el_row, {
            gutter: 10
          }, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 7
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "业务员姓名"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: form.value.salesmanKeyWd,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.value.salesmanKeyWd = $event)
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 7
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "团队名称"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: form.value.supplierKeyWd,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.value.supplierKeyWd = $event)
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 7
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "下级团队名称"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: form.value.structureName,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => form.value.structureName = $event)
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 3
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: ""
              }, {
                default: _withCtx(() => [_createVNode(_component_el_button, {
                  icon: "Search",
                  type: "primary",
                  onClick: _cache[3] || (_cache[3] = $event => table.value.commitProxy('reload'))
                }, {
                  default: _withCtx(() => [_hoisted_1]),
                  _: 1
                })]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_vxe_grid, _mergeProps({
          height: "630px",
          ref_key: "table",
          ref: table
        }, _unref(tableOptions)), null, 16)]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }

};